import { GetServerSidePropsContext } from 'next';

import { META_EXPLORE_TITLE } from '../src/constants/constants';
import { objectToQueryString } from '../src/helpers/url/queryUtils';
import { SSRResult } from '../src/interfaces/nextjs';
import { redirectExploreQuery } from '../src/views/Explore/context/helpers';
import ExploreWrapper from '../src/views/Explore/Explore';

export async function getServerSideProps({ query }: GetServerSidePropsContext): SSRResult {
  const oldQuery = objectToQueryString(query as Record<string, string>);
  const newQuery = redirectExploreQuery(oldQuery);

  if (oldQuery !== newQuery) {
    return {
      redirect: {
        permanent: true,
        destination: `/explore?${newQuery}`,
      },
    };
  }

  return {
    props: {
      _page: 'explore',
      _pageTitle: META_EXPLORE_TITLE,
    },
  };
}

export default ExploreWrapper;
